import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Tabs, Checkbox, Dropdown, Menu, Divider} from 'antd';
import {StarOutlined} from '@ant-design/icons';
import {setMapType, setPanelOptions, setSelectedDisplayOption, toggleMapButton} from '../slices/mapSettingSlice';

const {TabPane} = Tabs;

const MapSetting = () => {

    const dispatch = useDispatch();
    const mapSettings = useSelector((state) => state.mapSettings);
    const mapButton = useSelector((state) => state.mapSettings.mapButton);

    const mapOptions = [
        {label: 'Uydu', value: 'satellite'},
        {label: 'Yol Haritası', value: 'roadmap'},
        {label: 'Karma', value: 'hybrid'},
        {label: 'Arazi', value: 'terrain'},
    ];

    const displayOptions = [
        {label: 'Plaka', value: 'plateNumber'},
        {label: 'Şase Numarası', value: 'chassisNumber'},
        {label: 'Kapı Numarası', value: 'operationNumber'},
    ];

    const panelOptions = [
        {key: '2', label: 'Toplam KM', value: 'totalDistance'},
        {key: '3', label: 'Motor Soğ. Sıv. Sıc.', value: 'engineCoolantTemp'},
        {key: '4', label: 'Dış Ortam Sıcaklığı', value: 'ambientAirTemp'},
        {key: '5', label: 'Motor Devri', value: 'engineSpeed'},
        {key: '6', label: 'Araç Hızı', value: 'wheelBasedSpeed'},
        {key: '7', label: 'Servis Basıncı 1', value: 'serviceBrakeAirPressureCircuit1'},
        {key: '8', label: 'Motor Tork Yüzdesi', value: 'actualEnginePercentTorque'},
        {key: '9', label: 'Seyir Durumu', value: 'mcuid'},
        {key: '10', label: 'Servis Basıncı 2', value: 'serviceBrakeAirPressureCircuit2'},
        {key: '11', label: 'Yakıt Seviyesi', value: 'fuelLevel'},
        {key: '12', label: 'Ad Blue Seviyesi', value: 'AftertreatmentDieselExhaustFluidTank1Level'},
        {key: '13', label: 'Gaz Pedalı Pozisyonu', value: 'acceleratorPedalPosition'},
        {key: '14', label: 'Fren Pedalı Pozisyonu', value: 'brakePedalPosition'},
        {key: '15', label: 'Vites', value: 'currentGear'},
        {key: '16', label: 'Toplam Çalışma Saati', value: 'engineTotalHoursOfOperation'},
        {key: '17', label: 'Şase Numarası', value: 'chassisNumber'},
        {key: '18', label: 'Cihaz ID', value: 'vehicle_id'},
        {key: '19', label: 'Toplam Kullanılan Yakıt [L]', value: 'LiquetEngineTotalFuelUsed'},
        {key: '20', label: 'Ortalama Yakıt Tüketimi', value: 'AvgFuelConsumption'},
        {key: '21', label: 'Akü Voltajı', value: 'ain_ana5'},
        {key: '22', label: 'Kapı 1 Durumu', value: 'd1_os'},
        {key: '23', label: 'Kapı 2 Durumu', value: 'd2_os'},
        {key: '24', label: 'Kapı 3 Durumu', value: 'd3_os'},
        {key: '25', label: 'Kapı 4 Durumu', value: 'd4_os'},
        {key: '26', label: 'Alternatör 1', value: 'alt1'},
        {key: '27', label: 'Alternatör 2', value: 'alt2'},
        {key: '28', label: 'Alternatör 3', value: 'alt3'},
        {key: '29', label: 'Tarih / Saat', value: 'createdAt_last_data'},
    ];

    useEffect(() => {
        const allPanelValues = panelOptions.map((option) => option.value);
        dispatch(setPanelOptions(allPanelValues));
    }, [dispatch]);

    const handleSingleCheckboxChange = (selectedValue, type) => {
        if (type === 'map') {
            dispatch(setMapType(selectedValue));
        } else if (type === 'display') {
            dispatch(setSelectedDisplayOption(selectedValue));
        }
    };

    const menu = (
        <Menu style={{width: '450px'}}>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Gösterim Ayarları" key="1">
                    <div style={{marginBottom: '16px'}}>
                        {mapOptions.map((option) => (
                            <Checkbox
                                key={option.value}
                                checked={mapSettings.mapType === option.value}
                                onChange={() => handleSingleCheckboxChange(option.value, 'map')}
                            >
                                {option.label}
                            </Checkbox>
                        ))}
                    </div>
                    <Divider style={{margin: '16px 0'}}/>
                    <div style={{marginBottom: '16px'}}>
                        <label style={{display: 'block', marginBottom: '8px'}}>Harita Gösterim</label>
                        {displayOptions.map((option) => (
                            <Checkbox
                                key={option.value}
                                checked={mapSettings.selectedDisplayOption === option.value}
                                onChange={() => handleSingleCheckboxChange(option.value, 'display')}
                            >
                                {option.label}
                            </Checkbox>
                        ))}
                    </div>
                    <Divider style={{margin: '16px 0'}}/>
                    <div style={{marginBottom: '16px'}}>
                        <label style={{display: 'block', marginBottom: '8px'}}>Sağ Panel Gösterim</label>
                        <Checkbox.Group
                            style={{padding: '5px'}}
                            options={panelOptions.map((item) => ({
                                label: item.label,
                                value: item.value,
                            }))}
                            value={mapSettings.panelOptions}
                            onChange={(checkedValues) => dispatch(setPanelOptions(checkedValues))}
                        />
                    </div>
                </TabPane>
            </Tabs>
        </Menu>
    );

    const handleDropdownChange = (flag) => {
        dispatch(toggleMapButton());
    };

    return (
        <div style={{marginRight: '20px', cursor: 'pointer'}}>
            <Dropdown
                overlay={menu}
                trigger={['click']}
                visible={mapButton}
                onVisibleChange={handleDropdownChange}
            >
                <StarOutlined style={{fontSize: 16, color: 'white', cursor: 'pointer'}}/>
            </Dropdown>
        </div>
    );
};

export default MapSetting;
